<template>
  <div class="input-message-wrapper" :style="{ color: messageColor }">
    <slot name="icon">
      <info-warning class="input-message-icon" />
    </slot>
    <div class="input-message">{{ message }}</div>
  </div>
</template>

<script setup>
  import InfoWarning from '@/components/Icons/InfoWarning.vue'
  import { computed } from 'vue'
  const props = defineProps({
    message: {
      type: String,
      required: true,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
  })

  const messageColor = computed(() => {
    if (props.isError) {
      return '#F93950'
    }
    return props.color ?? '#A5A5A5'
  })
</script>

<style lang="scss" scoped>
  .input-message-wrapper {
    display: flex;
    align-items: start;
    .input-message-icon {
      flex: none;
    }
    .input-message {
      margin-left: 4px;
      font-size: 12px;
      line-height: 18px;
    }
  }
</style>
